import { Component, OnDestroy, OnInit } from '@angular/core';
import { isNullOrUndefined } from '@pineapplelab/util';
import { Subscription } from 'rxjs';
import { SpinnerService } from './services/spinner/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'festivalis-backoffice';
  showSpinner: boolean;
  subscription: Subscription;

	constructor(
		public spinnerService: SpinnerService,
   ) { }

  ngOnDestroy(): void {
		if (!isNullOrUndefined(this.subscription)) {
			this.subscription.unsubscribe();
		}
	}

  async ngOnInit(): Promise<void> {
		this.subscription = this.spinnerService.spinnerVisible$.subscribe(value => {
			setTimeout(() => { this.showSpinner = value; }, 0);
		});
  }
}
